export const HOME = {
  emergentLink: "home-emergent-link",
  heroCtaPortfolio: "hero-cta-portfolio",
  heroCtaBook: "hero-cta-book",
  ctaBookSection: "cta-book-section",
  categoryCard: "category-card",
  reviewCard: "review-card",
  newsletterSection: "home-newsletter-section",
  newsletterInput: "home-newsletter-input",
  newsletterName: "home-newsletter-name",
  newsletterSubmit: "home-newsletter-submit",
  newsletterConsent: "home-newsletter-consent",
};

export const HEADER = {
  logo: "header-logo",
  nav: "header-nav",
  navLink: "header-nav-link",
  mobileToggle: "header-mobile-toggle",
  mobileMenu: "header-mobile-menu",
  bookBtn: "header-book-btn",
};

export const FOOTER = {
  logo: "footer-logo",
  newsletterInput: "footer-newsletter-input",
  newsletterSubmit: "footer-newsletter-submit",
  socialInstagram: "footer-social-instagram",
  socialFacebook: "footer-social-facebook",
  socialPinterest: "footer-social-pinterest",
  phone: "footer-phone",
  email: "footer-email",
};

export const PORTFOLIO = {
  filterBtn: "portfolio-filter-btn",
  galleryItem: "portfolio-gallery-item",
  lightbox: "portfolio-lightbox",
  lightboxClose: "portfolio-lightbox-close",
  lightboxPrev: "portfolio-lightbox-prev",
  lightboxNext: "portfolio-lightbox-next",
};

export const CONTACT = {
  whatsappBtn: "contact-whatsapp",
  emailBtn: "contact-email",
  phoneBtn: "contact-phone",
};

export const SERVICE = {
  bookBtn: "service-book-btn",
};
